import axios from 'axios';
import _ from 'lodash';
import { Toast } from 'vant';

import HOSTS from '../config.js'

const instance = axios.create({
  baseURL: '/',
  withCredentials: true,
  headers: {
    'env': HOSTS.ENVIROMENT
  },
  timeout: 5000
});

instance.interceptors.request.use(function (request) {
  if (request.method === 'get' && request.params && !request.params._t) {
    request.params._t = Date.now()
  }
  return request
}, function (error) {
  return Promise.reject(error)
});

instance.interceptors.response.use((response) => {
  if (response.status === 200) {
    return response.data;
  }
  return Promise.reject(response)
}, (error) => {
  if (error.code === 'ECONNABORTED') {
    return Promise.reject(error);
  }
  return Promise.reject(error)
});

const request = {
  get(url, params = {}) {
    return new Promise((resolve, reject) => {
      instance.get(url, {
        params
      }).then(response => {
        return resolve(response);
      }).catch(error => {
        return reject(error);
      });
    })
  },
  post(url, params = {}) {
    return new Promise((resolve, reject) => {
      instance.post(url, params).then(response => {
        if (response.code === 0) {
          return resolve(response);
        }
        Toast(response.message);
        return reject(response.message);
      }).catch(error => {
        const msg = _.get(error, 'response.data.message');
        if (msg) {
          Toast(msg);
        } else if (error.message) {
          Toast(error.message);
        }
        return reject(error);
      })
    })
  },
  all(asyncArray) {
    return new Promise((resolve, reject) => {
      axios.all(asyncArray).then(axios.spread(function (acct, perms) {
        return resolve(acct, perms)
      }));
    })
  }
};

export default request;
